import { emitter, EVENTS } from '../utils/events'

const useManageEvents = () => {
  const headerMainBar = document.querySelector('[data-name="main-bar"]')
  const mobileNav = document.querySelector('[data-name="mobile-nav"]')
  const burgerBtn = document.querySelector('[data-name="burger"]')

  emitter.on(EVENTS.HEADER.HIDE, ({ active }) => {
    if (headerMainBar)
      headerMainBar.classList[active ? 'add' : 'remove']('header-hide')
  })

  emitter.on(EVENTS.HEADER.MINIMIZE, ({ active }) => {
    if (headerMainBar)
      headerMainBar.classList[active ? 'add' : 'remove']('header-minimize')
  })

  emitter.on(EVENTS.HEADER.MOBILE_NAV, ({ active }) => {
    window.lenis[active ? 'stop' : 'start']()
    if (mobileNav) mobileNav.classList[active ? 'add' : 'remove']('is-active')
    if (burgerBtn) burgerBtn.classList[active ? 'add' : 'remove']('is-active')
  })
}

export default useManageEvents
